import { render, staticRenderFns } from "./DataDialog.vue?vue&type=template&id=22bf1ef5&scoped=true"
import script from "./DataDialog.vue?vue&type=script&lang=js"
export * from "./DataDialog.vue?vue&type=script&lang=js"
import style0 from "./DataDialog.vue?vue&type=style&index=0&id=22bf1ef5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22bf1ef5",
  null
  
)

export default component.exports